'use client';

import { PropsWithChildren, ReactNode, useState } from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { Container } from '@/blocks/components/Container';
import { Select } from '@/blocks/components/Controls/Select';
import typography from '@/styles/typography.module.scss';

import { Card } from '@/app/[lang]/price-chart/[category]/[symbol]/components/Card';
import styles from '@/app/[lang]/price-chart/[category]/[symbol]/sections/CoinPageConditionsSection/styles.module.scss';

function Layout({ children }: PropsWithChildren) {
  return <div className={styles.tradeConditionsBlockLayout}>{children}</div>;
}

function SelectAndTable({ children }: PropsWithChildren) {
  return <div className={styles.selectAndTableContainer}>{children}</div>;
}

function LabeledSelectContainer({ children }: PropsWithChildren) {
  return <div>{children}</div>;
}

function SelectLabel({ children }: PropsWithChildren) {
  return <div className={classNames(typography.bodyM, styles.platformSelectLabel)}>{children}</div>;
}

export function CoinPageConditionsSection({
  slots,
}: {
  slots: { productLabel: ReactNode; list: ReactNode; card: ReactNode; disclaimer?: ReactNode }[];
}) {
  const [selectedProduct, setSelectedProduct] = useState<number>(0);
  const tr = useTranslations('pages.priceCharts.asset.sections.conditions');

  if (!slots.length) {
    return null;
  }

  return (
    <section>
      <Container>
        <Card
          className={styles.cardTradingConditions}
          header={tr.rich('title')}
          headerClassname={typography.h5}
        >
          <Layout>
            <SelectAndTable>
              <LabeledSelectContainer>
                <SelectLabel>{tr.rich('typeSelect.label')}</SelectLabel>
                <Select
                  value={selectedProduct}
                  onChange={(e) => {
                    setSelectedProduct(e.target.value as number);
                  }}
                  values={slots.map((slot, index) => ({
                    label: slot.productLabel as string,
                    value: index,
                  }))}
                />
              </LabeledSelectContainer>
              {slots[selectedProduct].list}
            </SelectAndTable>
            {slots[selectedProduct].card}
          </Layout>
        </Card>
        {slots[selectedProduct].disclaimer && (
          <p className={classNames(typography.bodyM, styles.disclaimer)}>
            {slots[selectedProduct].disclaimer}
          </p>
        )}
      </Container>
    </section>
  );
}
